import { render, staticRenderFns } from "./SyncGeneric.vue?vue&type=template&id=638b0bb4&scoped=true"
import script from "./SyncGeneric.vue?vue&type=script&lang=js"
export * from "./SyncGeneric.vue?vue&type=script&lang=js"
import style0 from "./SyncGeneric.vue?vue&type=style&index=0&id=638b0bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b0bb4",
  null
  
)

export default component.exports